import { apiCall, createQueryString } from "../imports"

const PREFIX = "shop/reports"

export default {

    getTopSell(filters) {
        return apiCall('get', `${PREFIX}${createQueryString(filters)}`)
    },
    getTopSellUser(filters) {
        return apiCall('get', `${PREFIX}/users${createQueryString(filters)}`)
    },
    getTopSellProvince(filters) {
        return apiCall('get', `${PREFIX}/provinces${createQueryString(filters)}`)
    },
    getTopSellCity(filters) {
        return apiCall('get', `${PREFIX}/cities${createQueryString(filters)}`)
    },
}